var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfileEdit/MemberProfileEditRecognitionItem.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEditRecognitionItem.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"MemberProfileEditRecognitionItem\">\n        <div class=\"MemberProfileEditRecognitionItem-inputWrapper\">\n            <input class=\"MemberProfileEditRecognitionItem-input\" type=\"text\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id")) {
t_5 += "data-id=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += " ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"text")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"text"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += ">\n            <textarea class=\"MemberProfileEditRecognitionItem-textarea\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id")) {
t_5 += "data-id=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += ">";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"text")) {
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"text"), env.opts.autoescape);
;
}
t_5 += "</textarea>\n\n            <div class=\"MemberProfileEditRecognitionItem-inputIcons\">\n                <div class=\"MemberProfileEditRecognitionItem-inputIcons-drag\">\n                    <div class=\"MemberProfileEditRecognitionItem-inputIcons-dragItem MemberProfileEditRecognitionItem-inputIcons-dragItem--top\"></div>\n                    <div class=\"MemberProfileEditRecognitionItem-inputIcons-dragItem MemberProfileEditRecognitionItem-inputIcons-dragItem--middle\"></div>\n                    <div class=\"MemberProfileEditRecognitionItem-inputIcons-dragItem MemberProfileEditRecognitionItem-inputIcons-dragItem--bottom\"></div>\n                </div>\n                <div class=\"MemberProfileEditRecognitionItem-inputIcons-delete\">\n                    <div class=\"MemberProfileEditRecognitionItem-inputIcons-deleteItem MemberProfileEditRecognitionItem-inputIcons-deleteItem--top\"></div>\n                    <div class=\"MemberProfileEditRecognitionItem-inputIcons-deleteItem MemberProfileEditRecognitionItem-inputIcons-deleteItem--bottom\"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("MemberProfileEditRecognitionItem");
context.setVariable("MemberProfileEditRecognitionItem", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfileEdit/MemberProfileEditRecognitionItem.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditRecognitionItem.jinja
// module id = 55
// module chunks = 0